import { useCallback } from "react";
import { authClient, useAuth } from "@/auth";
import { AlertBar } from "@/components/AlertBar";

/**
 * Banner displayed when an admin is impersonating a user.
 * Shows the impersonated user's info and a button to stop impersonating.
 */
export function ImpersonationBanner() {
	const authSession = useAuth();

	const handleStopImpersonating = useCallback(async () => {
		await authClient.admin.stopImpersonating();
		window.location.reload();
	}, []);

	if (!authSession.session?.impersonatedBy) {
		return null;
	}

	return (
		<AlertBar
			variant="info"
			title={`Impersonating ${authSession?.user?.name || authSession?.user?.email}`}
			action={
				<button
					type="button"
					className="btn btn-sm btn-white text-info border-none"
					onClick={handleStopImpersonating}
				>
					Stop Impersonating
				</button>
			}
		/>
	);
}
